import React from 'react';
import moment from 'moment';
import {Airplane} from 'components/Ui/Icon';
import {Activity, BlastengineMailCampaignMailBounceActivity} from 'api';
import useProjectName from './useProjectName';
import {Link} from 'react-router-dom';

interface MailCampaignActivity extends Activity {
  resource: BlastengineMailCampaignMailBounceActivity;
}

interface Props {
  activity: MailCampaignActivity;
}

const BlastengineMailCampaignMailBounceActivityComponent = ({
  activity,
}: Props) => {
  const {projectName} = useProjectName(activity);

  return (
    <div className="-ml-[15px] flex w-[480px]">
      <div className="relative flex w-[30px] h-[30px] my-auto mr-5">
        <Airplane />
      </div>
      <span className="min-w-0 max-w-full mt-1 flex flex-col flex-1">
        {projectName && (
          <div className="text-[var(--text-color-2)] text-[10px] leading-[14px] mb-1">
            {projectName}
          </div>
        )}
        <div className="text-[var(--text-color-2)] text-[10px] leading-[14px] mb-1">
          <Link
            target="_blank"
            to={`/mail_campaigns/${activity.resource.mailCampaignSend.mailCampaign.uuid}`}>
            {activity.resource.mailCampaignSend.mailCampaign.title}
          </Link>
        </div>
        <div className="text-[var(--text-color-2)] text-[10px] leading-[14px] mb-1">
          バウンス
        </div>
      </span>
      <span className="mt-auto ml-auto">
        {moment(activity.createdAt).format('YYYY/MM/DD HH:mm')}
      </span>
    </div>
  );
};

export default BlastengineMailCampaignMailBounceActivityComponent;
